<template>
  <!-- <div v-if="isEmpty" class="text-dark-blue car-card__empty">
    No cars
  </div> -->
  <div v-if="car && car.id" class="car-card">
    <div class="car-card__image-container">
      <a 
        :class="{ 'car-card__disabled-link': disabledLink }"
        target="_blank" 
        :href="toCarLink" 
        @click.stop
      >
        <img v-if="car.imageUrl" :src="car.imageUrl" alt="" />
      </a>
    </div>
    <div class="car-card__body">
      <a
        :href="toCarLink"
        target="_blank"
        class="car-card__title"
        :class="{ 'car-card__disabled-link': disabledLink }"
        @click.stop
        >{{ car.title }}</a
      >
      <div class="car-card__info" v-if="car.showInfo">
        <div class="car-card__make">
            Make:
            <span class="car-card__make-value">{{car.make}}</span>
        </div>
        <div class="car-card__year" v-if="car.year">
            Year:
            <span class="car-card__year-value">{{car.year}}</span>
        </div>
        <div class="car-card__model">
            Model:
            <span class="car-card__model-value">{{car.model}}</span>
        </div>
        <div class="car-card__time-info">
          <div class="car-card__time" v-if="car.showCreatedDate">
              Created At:
              <span class="car-card__time-value">{{createdDate}}</span>
          </div>
          <div class="car-card__time" v-if="car.showStartDate">
              Start At:
              <span class="car-card__time-value">{{startDate}}</span>
          </div>
          <div class="car-card__time" v-if="car.showEndDate">
              Finished At:
              <span class="car-card__time-value">{{endDate}}</span>
          </div>
        </div>
      </div>
      <div class="car-card__end-line" v-else>
        <div
          class="car-card__round-live"
          :class="{ 'car-card__round-live_not-ended': !isEndedCar }"
        />
        <div class="car-card__date-label">
          {{ isNotStarted ? "Start at:" : "End date:" }}
        </div>
        <div class="car-card__date">
          {{ isNotStarted ? startDate : isEndedCar ? carDate : endDate }}
        </div>
      </div>
      <VSeeAllLink :to="toCarsLink" v-if="!car.hideLink"/>
    </div>
  </div>
</template>
<script>
import getTimeDiff from "@/utils/time/getTimeDiff";
import moment from "moment";
import {
  isEndedCar,
  getCarEndDate,
  getCarStartDate,
  getCarCreatedDate,
  isNotStarted
} from "@/utils/validation/car";
import URLS from '@/constants/url';
import { encodeToBase62 } from "@/utils/slug";

export default {
  name: "VCarCard",

  props: {
    car: {
      type: Object
    },
  },

  data: () => ({
    isNotStarted: false
  }),

  computed: {
    toCarLink() {
      return `${URLS.app}/auctions/${this.car.year
              .trim()
              .replaceAll(" ", "-")}-${this.car.make
              .trim()
              .replaceAll(" ", "-")}-${this.car.model
              .trim()
              .replaceAll(" ", "-")}/${encodeToBase62(this.car.uuid)}`
    },
    toCarsLink() {
      return "/vehicle-manager";
    },
    carDate() {
      return this.car.endDate
        ? getTimeDiff(moment(), this.car.endDate, false, true) + " ago"
        : "";
    },
    isEmpty() {
      return !this.car.endDate;
    },
    isEndedCar() {
      return isEndedCar(this.car) && !this.isNotStarted;
    },
    createdDate() {
      return getCarCreatedDate(this.car)
    },
    endDate() {
      return getCarEndDate(this.car);
    },
    startDate() {
      return getCarStartDate(this.car) || '';
    },
    disabledLink() {
      return this.car.disabledLink
    }
  },

  watch: {
    car(v) {
      this.isNotStarted = isNotStarted(v);
    }
  }
};
</script>
